<template>
  <div>
    <p>
      {{ $t('filters.confirm_delete') }}
      <strong>{{ conditionToDelete.name }}</strong>
    </p>
    <div class="text-right">
      <button
        type="button"
        class="btn btn-default"
        @click="setConditionToDelete()"
      >
        {{ $t('filters.confirm_delete_no') }}
      </button>
      <button
        type="button"
        class="btn btn-danger"
        @click="
          deleteDisplayCondition({
            mergeTagsSource: templateData.mergeTagsSource.id,
            conditionId: conditionToDelete.id
          })
        "
      >
        {{ $t('filters.confirm_delete_yes') }}
      </button>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';

export default {
  name: 'ConfirmDeleteDisplayCondition',
  computed: {
    ...mapState({
      conditionToDelete: state => state.displayModule.conditionToDelete,
      templateData: state => state.templateData
    })
  },
  methods: {
    ...mapActions('displayModule', ['deleteDisplayCondition']),
    ...mapMutations('displayModule', ['setConditionToDelete'])
  }
};
</script>

<style scoped>
button {
  margin: 0 0.5em;
}
</style>
